import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EventLogComponent from './EventLogComponent';
import { getModel } from './selectors';
import * as actions from './actions';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';
import { apiCallStatus } from 'helpers/constants';
import './style.scss';


const EventLogContainer = (props) => {

	useEffect(() => {
		const loadingStatus = props.model.eventLogLoadingData?.loadingStatus;
		return () => {
			// Clear store only when an error state exits — on unmount or when retry clears the error.
			// Normal navigation (no error) preserves the store and filter selections.
			if (loadingStatus === apiCallStatus.ERROR) {
				props.actions?.clearStore?.();
			}
		};
	}, [props.model.eventLogLoadingData?.loadingStatus]);

	return <div id='event-log-tab-container'>
		<EventLogComponent {...props} />
	</div>;
};

const mapStateToProps = (state) => {
	const model = getModel(state);
	return {
		model
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
};

const eventLogContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(EventLogContainer);
const EventLogContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(eventLogContainerWithErrorBoundaryTrigger);

EventLogContainer.propTypes = {
	model: PropTypes.shape({
		eventLogLoadingData: PropTypes.shape({
			loadingStatus: PropTypes.string,
		}),
	}),
	actions: PropTypes.shape({
		clearStore: PropTypes.func,
	}),
};

export default EventLogContainerConn;
